import { render, staticRenderFns } from "./LoginExpired.vue?vue&type=template&id=67c0834e&"
import script from "./LoginExpired.vue?vue&type=script&lang=js&"
export * from "./LoginExpired.vue?vue&type=script&lang=js&"
import style0 from "./LoginExpired.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports